var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r1"},[_c('img',{staticClass:"pie-img",attrs:{"src":require("@/assets/template_1/pie-bg.png"),"alt":""}}),_c('div',{ref:"lchart",staticClass:"lchart"}),_c('div',{staticClass:"prey-line"}),_c('div',{staticClass:"prey-line1"})])
}
var staticRenderFns = []

export { render, staticRenderFns }